import React from "react";
import { TimerIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  const dark = tone === "dark";
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-90" data-mp="3c0kyrpwpmr4u">
      <p className={`flex items-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? "text-gold" : "text-plum-700"}`} data-id="element-91" data-mp="3h1qttudueqhj">
        <TimerIcon className="h-4 w-4" aria-hidden data-id="element-92" data-mp="3262q06cfs5e6" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2" data-id="element-93" data-mp="374vvpclhes3s">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-94" data-mp="10d4prpgbyaj7" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-95" data-mp="15b6dwosm501j">
              <span className={`flex h-[68px] w-[68px] items-center justify-center rounded-xl font-display text-4xl font-extrabold tabular-nums ${dark ? "bg-white text-plum-900" : "bg-plum-800 text-white"}`} data-id="element-96" data-mp="15an0nldwqztu">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-plum-100" : "text-ink/50"}`} data-id="element-97" data-mp="12rwpil2o84kc">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-display text-3xl font-bold ${dark ? "text-white" : "text-plum-800"}`} data-id="element-98" data-mp="a49b5nrzua65">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}